module.exports = __webpack_public_path__ + "img/bg2.d416642b.png";